/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import dayjs from "dayjs";
import { SortType } from "../types/input";

function getSortValue(a, b, key, sortType: SortType) {
    let aVal;
    let bVal;
    if (typeof key === "function") {
        aVal = key(a);
        bVal = key(b);
    } else {
        aVal = a[key];
        bVal = b[key];
    }

    // nulls sort after anything else
    if (aVal === null || aVal === undefined) {
        return 1;
    }
    if (bVal === null || bVal === undefined) {
        return -1;
    }
    if (typeof aVal === "boolean" && typeof bVal === "boolean") {
        return aVal === bVal
            ? 0
            : sortType === "asc"
              ? bVal - aVal
              : aVal - bVal;
    }
    if (dayjs(aVal).isValid() && dayjs(bVal).isValid()) {
        if (dayjs(aVal).isBefore(dayjs(bVal))) {
            return sortType === "asc" ? -1 : 1;
        }
        if (dayjs(aVal).isAfter(dayjs(bVal))) {
            return sortType === "asc" ? 1 : -1;
        }
        return 0;
    }
    if (aVal < bVal) {
        return sortType === "asc" ? -1 : 1;
    }
    if (aVal > bVal) {
        return sortType === "asc" ? 1 : -1;
    }
    return 0;
}

export function sortArrayByKey<T>(
    array: T[],
    key: keyof T | ((value: T) => unknown),
    sortType: SortType = "asc",
    secondaryKey?: keyof T | ((value: T) => unkown),
    secondarySortType?: SortType = "asc",
) {
    if (sortType === "none") return array;

    return array.sort((a, b) => {
        const sortValue = getSortValue(a, b, key, sortType);
        if (sortValue !== 0) return sortValue;
        if (sortValue === 0 && secondaryKey) {
            return getSortValue(a, b, secondaryKey, secondarySortType);
        }
    });
}

export function uniqueStrings(strings: string[]): string[] {
    return Array.from(new Set(strings));
}
